export default __webpack_public_path__ + "static/media/aiColorinActive.bbffdf9e.svg";